/* ============================================================================
   facil. — MINI-DIAGNOSTIC KIT (popup). Conseille UN modèle de cils sans quitter
   la PDP, puis l'ajoute au kit en 1 clic (event facil:kit-pick → façade bundle).
   4 questions (teinte, intensité, style, œil) — scoring dupliqué de
   facil-diagnostic.js (à garder en phase). Gagnant contraint au pool du kit.
   ============================================================================ */
(function () {
  'use strict';
  if (window.__facilKitQuiz) return;
  window.__facilKitQuiz = true;

  var modal = document.querySelector('[data-fb-quiz]');
  var openBtn = document.querySelector('[data-fb-quiz-open]');
  if (!modal || !openBtn) return;
  var mount = document.querySelector('[data-facil-bundle]');

  /* Données modèle (name + mini) = JSON déjà rendu pour la façade. Clés = nom MAJ avec espace. */
  var MODELS = {};
  try { MODELS = JSON.parse(document.querySelector('[data-facil-bundle-models]').textContent); } catch (e) {}

  var SCORE_KEYS = ['MARRON', 'NUDE', 'SUBTIL', 'VOLUME', 'SMOKY', 'SMOKY_BROWN'];
  var BESTSELLERS = ['MARRON', 'NUDE', 'VOLUME', 'SUBTIL', 'SMOKY', 'SMOKY_BROWN'];
  function dataKey(k) { return k.replace('_', ' '); } // SMOKY_BROWN -> "SMOKY BROWN" (clé du JSON façade)

  var QUESTIONS = [
    { id: 'teinte', title: 'La teinte qui te ressemble', options: [
      { label: 'De la chaleur, du brun', scores: { MARRON: 2, SMOKY_BROWN: 2 }, flags: { teinte: 'brun' } },
      { label: 'Du noir, classique',     scores: { NUDE: 1, SUBTIL: 1, VOLUME: 1, SMOKY: 1 }, flags: { teinte: 'noir' } },
      { label: 'Je ne sais pas encore',  scores: {}, idk: true }
    ]},
    { id: 'intensite', title: 'L’intensité que tu cherches', options: [
      { label: 'À peine là, naturel',     scores: { NUDE: 3, MARRON: 2 }, flags: { intensite: 'légère' } },
      { label: 'Visible mais élégant',    scores: { SUBTIL: 3, SMOKY_BROWN: 2 }, flags: { intensite: 'moyenne' } },
      { label: 'Intense, tout en regard', scores: { VOLUME: 3, SMOKY: 2 }, flags: { intensite: 'forte' } }
    ]},
    { id: 'style', title: 'Le style que tu vises', options: [
      { label: 'Effet mascara, mes cils en mieux',  scores: { NUDE: 2 } },
      { label: 'Doux, juste rehaussé',              scores: { MARRON: 2 } },
      { label: 'Whispy, légèrement destructuré',    scores: { SUBTIL: 2 } },
      { label: 'Volume russe, comme en institut',   scores: { VOLUME: 2 } },
      { label: 'Smoky, un regard profond',          scores: { SMOKY: 2 }, scoresIf: { flag: 'teinte', value: 'brun', scores: { SMOKY_BROWN: 2 } } }
    ]},
    { id: 'oeil', title: 'La forme de ton œil', options: [
      { label: 'En amande',      scores: { SUBTIL: 2 } },
      { label: 'Rond',           scores: { VOLUME: 1, NUDE: 1 } },
      { label: 'Je ne sais pas', scores: {}, idk: true }
    ]}
  ];

  /* ---- Pool du kit (clés de scoring dispo). ---- */
  function poolKeys() {
    var raw = (mount && mount.getAttribute('data-fb-models')) || '';
    if (!raw) return SCORE_KEYS.slice();
    var set = raw.split(',').map(function (s) { return s.trim().toUpperCase(); });
    var k = SCORE_KEYS.filter(function (sk) { return set.indexOf(dataKey(sk).toUpperCase()) !== -1; });
    return k.length ? k : SCORE_KEYS.slice();
  }

  /* ---- Scoring (repris du diagnostic). ---- */
  function compute(answers) {
    var scores = {}, flags = {}, idk = 0;
    SCORE_KEYS.forEach(function (k) { scores[k] = 0; });
    answers.forEach(function (oi, qi) { if (oi == null) return; var o = QUESTIONS[qi].options[oi]; if (o.flags) Object.keys(o.flags).forEach(function (f) { flags[f] = o.flags[f]; }); });
    answers.forEach(function (oi, qi) {
      if (oi == null) return; var o = QUESTIONS[qi].options[oi];
      if (o.idk) idk++;
      if (o.scores) Object.keys(o.scores).forEach(function (m) { scores[m] += o.scores[m]; });
      if (o.scoresIf && flags[o.scoresIf.flag] === o.scoresIf.value) Object.keys(o.scoresIf.scores).forEach(function (m) { scores[m] += o.scoresIf.scores[m]; });
    });
    return { scores: scores, flags: flags, idk: idk };
  }
  function intensityPreferred(i) { return i === 'légère' ? ['NUDE', 'MARRON'] : i === 'moyenne' ? ['SUBTIL', 'SMOKY_BROWN'] : i === 'forte' ? ['VOLUME', 'SMOKY'] : []; }
  function resolve(c) {
    var keys = poolKeys();
    var sorted = keys.slice().sort(function (a, b) { return c.scores[b] - c.scores[a]; });
    var max = c.scores[sorted[0]], second = c.scores[sorted[1]] != null ? c.scores[sorted[1]] : 0;
    var tied = sorted.filter(function (k) { return c.scores[k] === max; });
    if (c.idk >= 2 && (max - second) < 2) {
      return BESTSELLERS.filter(function (k) { return keys.indexOf(k) !== -1; })[0] || sorted[0];
    }
    if (tied.length === 1) return tied[0];
    var pref = intensityPreferred(c.flags.intensite).filter(function (k) { return tied.indexOf(k) !== -1; });
    if (pref.length) return pref[0];
    return BESTSELLERS.filter(function (k) { return tied.indexOf(k) !== -1; })[0] || tied[0];
  }

  /* ---- DOM ---- */
  var qScreen = modal.querySelector('[data-fbq-question]');
  var rScreen = modal.querySelector('[data-fbq-result]');
  var qCount = modal.querySelector('[data-fbq-count]');
  var qTitle = modal.querySelector('[data-fbq-title]');
  var qOptions = modal.querySelector('[data-fbq-options]');
  var rName = modal.querySelector('[data-fbq-name]');
  var rPhrase = modal.querySelector('[data-fbq-phrase]');
  var rMedia = modal.querySelector('[data-fbq-media]');
  var rImg = modal.querySelector('[data-fbq-img]');
  var pickBtn = modal.querySelector('[data-fbq-pick]');

  var step = 0, answers = [], winner = null;

  function escapeHtml(s) { return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }

  function showScreen(which) {
    if (qScreen) qScreen.hidden = which !== 'q';
    if (rScreen) rScreen.hidden = which !== 'r';
  }

  function renderQuestion() {
    var q = QUESTIONS[step];
    if (qCount) qCount.textContent = 'Question ' + (step + 1) + ' / ' + QUESTIONS.length;
    if (qTitle) qTitle.textContent = q.title;
    qOptions.innerHTML = '';
    q.options.forEach(function (opt, oi) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'facil-fbq__option';
      b.textContent = opt.label;
      b.addEventListener('click', function () { choose(oi); });
      qOptions.appendChild(b);
    });
    if (qScreen) { qScreen.style.animation = 'none'; void qScreen.offsetWidth; qScreen.style.animation = ''; } // relance la transition douce
    showScreen('q');
    var first = qOptions.querySelector('button'); if (first) { try { first.focus(); } catch (e) {} }
  }

  function choose(oi) {
    answers[step] = oi;
    if (step < QUESTIONS.length - 1) { step++; renderQuestion(); }
    else showResult();
  }

  function showResult() {
    winner = resolve(compute(answers));
    var m = MODELS[dataKey(winner)] || {};
    if (rName) rName.textContent = m.name || dataKey(winner).toLowerCase() + '.';
    if (rPhrase) rPhrase.textContent = m.mini || '';
    if (rMedia && rImg) {
      var src = m.img || (m.images && m.images[0]) || '';
      if (src) { rImg.src = src; rMedia.hidden = false; } else { rMedia.hidden = true; }
    }
    if (pickBtn) pickBtn.textContent = 'Choisir ' + (m.name || '');
    showScreen('r');
  }

  function open() { step = 0; answers = []; winner = null; renderQuestion(); modal.hidden = false; document.documentElement.style.overflow = 'hidden'; }
  function close() { modal.hidden = true; document.documentElement.style.overflow = ''; }

  openBtn.addEventListener('click', function (e) { e.preventDefault(); open(); });
  Array.prototype.slice.call(modal.querySelectorAll('[data-fbq-close]')).forEach(function (c) { c.addEventListener('click', close); });
  var restart = modal.querySelector('[data-fbq-restart]'); if (restart) restart.addEventListener('click', function () { step = 0; answers = []; renderQuestion(); });
  if (pickBtn) pickBtn.addEventListener('click', function () {
    if (winner) document.dispatchEvent(new CustomEvent('facil:kit-pick', { detail: { model: dataKey(winner) } }));
    close();
  });
  document.addEventListener('keydown', function (e) { if (!modal.hidden && e.key === 'Escape') close(); });
})();
